(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/matchen/assets/javascripts/objects/betslip.js') >= 0) return;  svs.modules.push('/modules/matchen/assets/javascripts/objects/betslip.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.matchen = svs.matchen || {};
  svs.matchen.objects = svs.matchen.objects || {};

  svs.matchen.objects.BetslipHandler = Marionette.MnObject.extend({
    payFooter: null,

    betslipExpanded: null,

    options: {
      hideValidationError: true
    },

    initialize: function() {
      _.bindAll(this, 'onBetslipOpened');

      this.storeState = {
        type: '',
        product: 'matchen',
        validOpenState: this.options.model.get('isValid')
      };
      this.relativeLayout = true;
      this.betslip = new svs.app.betslipv2.Betslip(this);

      svs.matchen.views.betslip = this.betslip;

      this.betslip.hideBetslip(); 

      this.betslip.getRegion('betslipFooter').show(new svs.matchen.views.BetslipFooter({
        model: this.options.model
      }));
      this.wasValid = this.options.model.get('isValid');

      this.initListeners();

      this.onCouponChange();
    },

    initRelativeBetslip: function() {
      var self = this;
      this.scrollContent = svs.core.detect.formfactor.mobile() ?
        $('#main-content') :
        $('#coupon');
      if (!svs.core.detect.formfactor.mobile()) {
        this.swiperContainer = $('.js-swiper-container');
      }
      this.betslipWrapper = $('#betslip-wrapper');
      this.betslipPosition = $('.betslip-position-tag');
      this.actionbar = $('#action-wrapper');
      this.betslipFooter = $('#betslip-footer');
      this.betslipPaymentArea = $('.js-betslip-payment-area');

      this.betslipWrapper.width(this.scrollContent[0].clientWidth);
      this.actionbar.width(this.scrollContent[0].clientWidth);

      if (!svs.core.detect.formfactor.mobile()) {
        $(window).on('resize', function() {
          self.betslipWrapper.width(self.scrollContent[0].clientWidth);
          self.actionbar.width(self.scrollContent[0].clientWidth);
        });

        $(window).on('resizeMultiSwiper', function() {
          self.betslipWrapper.width(self.overload.scrollContent[0].clientWidth);
          self.actionbar.width(self.scrollContent[0].clientWidth);
        });
      }
      this.betslipFooter.off('click', _.bind(this.scrollToBetslip, this));
      this.betslipFooter.on('click', _.bind(this.scrollToBetslip, this));

      svs.matchen.views.betslip.showBetslip();
    },

    scrollToBetslip: function(e) {
      e.preventDefault();
      var scrollToBetslip = this.scrollContent.height();
      if (svs.core.detect.formfactor.mobile()) {
        $('html, body')
          .stop()
          .animate({ scrollTop: scrollToBetslip }, 400, 'swing');
      } else {
        $(this.swiperContainer)
          .has('#coupon')
          .stop()
          .animate({ scrollTop: scrollToBetslip }, 400, 'swing');
      }
    },

    additionalScrollHeight: function(betslip) {
      betslip.overload.betslipOffsetTop = svs.core.detect.formfactor.mobile() ?
        betslip.overload.betslipPosition.offset().top :
        betslip.overload.betslipPosition[0].offsetTop;
    },

    initListeners: function() {
      this.listenTo(this.options.model, 'change', this.onCouponChange);
      this.listenTo(this.betslip, 'betslipOpened', this.onBetslipOpened);
    },

    onBetslipOpened: function() {
      if (this.options.model.get('errorMessage')) {
        this.betslip.scrollTo(0, 0);
      }
    },

    onCouponChange: function() {
      this.wasValid = this.options.model.get('isValid');

      if (svs.core.detect.formfactor.mobile()) {
        svs.sport.actionbar.reposition();
      }
    },

    openBetslip: function() {
    },

    closeBetslip: function(betslip) {
      betslip.getRegion('betslipContent').empty();
      betslip
        .getRegion('betslipFooter')
        .show(new svs.matchen.views.BetslipFooter({ model: this.options.model }));
    },

    onDestroy: function() {
      svs.matchen.app.skeleton.getRegion('regionBetslip').reset();

      if (this.betslip) {
        this.betslip = null;
        delete this.betslip;
      }
    }
  });
})(Backbone, _, svs);


 })(window);